import Button from "componentsv2/button/Button";

const style = "flex justify-center md:justify-end my-1 gap-x-3 pb-0 px-2";
const SIZE = "min-w-[150px] sm:w-1/2 md:w-1/4";

function ButtonsGroup({
  buttons,
  handleClose,
  handleButton,
  handleAccept,
  handleNot,
}) {
  if (!buttons || buttons.length === 0) {
    return null;
  }
  const defaultButtons = {
    cancel: (
      <Button
        key="cancel"
        color="rose"
        size={SIZE}
        onClick={handleClose}
        content="button.cancel"
        noFill={true}
      />
    ),
    // no: (
    //   <Button
    //     key="no"
    //     color="black"
    //     size={SIZE}
    //     onClick={handleClose}
    //     content="button.no"
    //   />
    // ),
    // ok: (
    //   <Button
    //     key="ok"
    //     color="blue"
    //     size={SIZE}
    //     onClick={handleAccept}
    //     content="button.ok"
    //   />
    // ),
    // yes: (
    //   <Button
    //     key="yes"
    //     color="blue"
    //     size={SIZE}
    //     onClick={handleAccept}
    //     content="button.yes"
    //   />
    // ),
    close: (
      <Button
        key="close"
        color="black"
        size={SIZE}
        onClick={handleClose}
        content="button.close"
      />
    ),
  };

  const _buttons = [];
  if (buttons.length > 0) {
    for (const btn of buttons) {
      let button = defaultButtons[btn.name];
      if (!button) {
        const color = btn.color ?? "blue";
        // This part is for custom buttons
        const label = btn.label || btn.name;
        const onClick = btn.onClick || btn.method;
        button = (
          <Button
            key={btn.name}
            color={color}
            size={SIZE}
            onClick={() => onClick(btn)}
            content={label}
          />
        );
      }
      _buttons.push(button);
    }
  }

  return (
    <div id="buttons-group" className={style}>
      {_buttons}
    </div>
  );
}

export default ButtonsGroup;
